var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Flex, styled } from '@creditas-ui/react';
var Container = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1;\n  box-sizing: border-box;\n  overflow-y: auto;\n  scroll-behavior: smooth;\n\n  & > * {\n    height: 100%;\n    box-sizing: border-box;\n  }\n"], ["\n  flex: 1;\n  box-sizing: border-box;\n  overflow-y: auto;\n  scroll-behavior: smooth;\n\n  & > * {\n    height: 100%;\n    box-sizing: border-box;\n  }\n"])));
export { Container };
var templateObject_1;
//# sourceMappingURL=DrawerBody.style.js.map